import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { compose } from 'redux';
import Grid from '@mui/material/Grid';
import Star from '@mui/icons-material/Star';
import { Card, IconButton } from '@totalsoft/rocket-ui';
import { FolderAssetImage, FolderListItemContent } from './FolderListStyles';
import { ListEditIcon, ListEditLink } from 'components/common/CommonStyles';

const FolderListItem = ({ t, internalOnEdit, fieldsToShow, item }) => {
  return (
    <Card disablePadding>
      <FolderListItemContent item container spacing={1} colors={item}>
        <Grid item container xs={12} sm={4} lg={2} pr={2} alignItems='center'>
          {fieldsToShow.includes('assetImage') && item.defaultUrl && <FolderAssetImage src={item.defaultUrl} alt='asset_image' />}
        </Grid>
        <Grid item container spacing={1} xs={12} lg={fieldsToShow.includes('assetImage') ? 10 : 12}>
          {fieldsToShow.includes('folderNumber') && (
            <Grid item xs={12} sm={6} md={4}>
              <strong> {t('FolderList.FolderNumber')}</strong>: <span>{item.folderNumber}</span>
            </Grid>
          )}
          {fieldsToShow.includes('offerNumbers') && (
            <Grid item xs={12} sm={6} md={4}>
              <strong> {t('FolderList.OfferNumbers')}</strong>: <span>{item.offerNumbers}</span>
            </Grid>
          )}
          {fieldsToShow.includes('clientName') && (
            <Grid item xs={12} sm={6} md={4}>
              <strong> {t('FolderList.Client')}</strong>: <span>{item.clientName}</span>
            </Grid>
          )}
          {fieldsToShow.includes('financedAmount') && (
            <Grid item xs={12} sm={6} md={4}>
              <strong> {t('FolderList.FinancedAmount')}</strong>:{' '}
              <span>
                {item.financedAmount ? t('NUMBER', { number: item.financedAmount }) : ''} {item.currencyCode}
              </span>
            </Grid>
          )}
          {fieldsToShow.includes('folderDate') && (
            <Grid item xs={12} sm={6} md={4}>
              <strong>{t('FolderList.FolderDate')}</strong>: <span>{t('DATE', { date: item.folderDate })}</span>
            </Grid>
          )}
          {fieldsToShow.includes('user') && (
            <Grid item xs={12} sm={6} md={4}>
              <strong> {t('FolderList.User')}</strong>:{' '}
              <span>
                {item.isReplacementFolder ? <Star /> : ''} {item.responsibleName}
              </span>
            </Grid>
          )}
          {fieldsToShow.includes('dealer') && (
            <Grid item xs={12} sm={6} md={4}>
              <strong> {t('FolderList.Dealer')}</strong>: <span>{item.dealer}</span>
            </Grid>
          )}
          {fieldsToShow.includes('stateName') && (
            <Grid item xs={12} sm={6} md={4}>
              <strong> {t('FolderList.State')}</strong>: <span>{item.stateName}</span>
            </Grid>
          )}
          {fieldsToShow.includes('financialProductName') && (
            <Grid item xs={12} sm={6} md={4}>
              <strong> {t('FolderList.FinancialProduct')}</strong>: <span>{item.financialProductName}</span>
            </Grid>
          )}
          {fieldsToShow.includes('salesChannel') && (
            <Grid item xs={12} sm={6} md={4}>
              <strong> {t('FolderList.SalesChannel')}</strong>: <span>{item.channel}</span>
            </Grid>
          )}
          {fieldsToShow.includes('contractTypeName') && (
            <Grid item xs={12} sm={6} md={4}>
              <strong> {t('FolderList.ContractType')}</strong>: <span>{item.folderTypeName}</span>
            </Grid>
          )}
        </Grid>
        <ListEditLink to={internalOnEdit(item)}>
          <IconButton id='offerList_editBtn' size='small' color='primary' tooltip={t('Edit')}>
            <ListEditIcon />
          </IconButton>
        </ListEditLink>
      </FolderListItemContent>
    </Card>
  );
};

FolderListItem.propTypes = {
  t: PropTypes.func.isRequired,
  internalOnEdit: PropTypes.func.isRequired,
  item: PropTypes.object.isRequired,
  fieldsToShow: PropTypes.array.isRequired
};

export default compose(withTranslation())(FolderListItem);
